
  Vue.component('seeker-lists-details', {
    props: {
      searchCurriculaUrl: { type: String, required: true }
    },
    data() {
      return {
        isLocalCurriculaLoaded: false,
        localCurricula: [],
        oldListId: Number,
        showArrow: false,
        demoMode: false
      }
    },
    pinia: Vue.pinia,
    template: '#seeker-lists-details',
    computed: {
      ...Pinia.mapStores(useCurriculumMemosStore),
      // seekerListsStore data
      ...Pinia.mapState(useSeekerListsStore, {
        loading: store => store.loading,
        lists: store => store.lists,
        list: store => store.selectedList,
        curricula: store => store.selectedListCurricula
      })
    },
    methods: {
      // seekerListsStore actions
      ...Pinia.mapActions(useSeekerListsStore, [
        'addToListAtIndex',
        'getListDetails',
        'getListCurricula',
        'deleteSeekerList',
        'removeFromList'
      ]),
      exitDemoMode() {
        ;(this.demoMode = false), (this.localCurricula = [])
      },
      enterDemoMode() {
        this.demoMode = true
        this.localCurricula = [
          {
            Id: 19,
            AppUserId: 'f72e6575-0000-4774-90e3-9d9ef1b7fef8',
            ImageUrl: '/files/curricula/default/_widgetimage.jpg',
            Firstname: 'Michele',
            Lastname: '',
            CurrentWorkPosition: 'Responsabile Programmatore',
            EmailConfirmed: true,
            Enabled: true,
            Latitude: 45.44285099999999,
            Mobile: '',
            Email: 'michele@ggmail.com',
            Longitude: 9.5596544,
            City: 'Agnadello',
            isRemoved: false
          },
          {
            Id: 76,
            AppUserId: '034d8df6-0000-4397-acda-57a49522b586',
            ImageUrl: '/files/curricula/default/_widgetimage.jpg',
            Firstname: 'Gaia',
            Lastname: '',
            CurrentWorkPosition: 'Web developer c#',
            EmailConfirmed: true,
            Enabled: true,
            Latitude: 45.570318999999984,
            Mobile: '',
            Email: 'gaia@ggmail.com',
            Longitude: 9.522033800000003,
            City: "Vaprio d'Adda",
            isRemoved: false
          },
          {
            Id: 55587,
            AppUserId: '5272688b-0000-4bfc-8df3-417b84b3c2b8',
            ImageUrl: '/files/curricula/default/_widgetimage.jpg',
            Firstname: 'Andrea',
            Lastname: '',
            CurrentWorkPosition: 'App developer (flutter dart)',
            EmailConfirmed: true,
            Enabled: true,
            Latitude: 45.531314399999985,
            Mobile: null,
            Email: 'andrea@ggmail.com',
            Longitude: 9.702998400000013,
            City: 'Morengo',
            isRemoved: false
          }
        ]
      },
      confirmDeleteSeekerList() {
        if (!this.list) return

        EventBus.$emit('vnPopup', {
          type: 'success',
          message: `Sei sicuro di voler cancellare definitivamente la lista: <b>${this.list.Name}</b>&nbsp;?`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                this.deleteSeekerList(this.list.Name)
              },
              style: 'info'
            },
            {
              label: 'Annulla',
              icon: 'fa-times',
              action: () => {}
            }
          ]
        })
      },

      findIndexToAddCurriculum(currentIndex) {
        let nextRealCurriculumId = null
        let returnedIndex
        this.localCurricula.forEach((curriculum, index) => {
          if (index > currentIndex)
            if (curriculum.isRemoved === false) {
              nextRealCurriculumId = curriculum.Id
            }
        })
        if (nextRealCurriculumId != null) {
          this.curricula.forEach((curriculum, index) => {
            if (curriculum.Id === nextRealCurriculumId) {
              returnedIndex = index
            }
          })
        } else returnedIndex = this.curricula.length - 1
        return returnedIndex
      },

      setRemoveOnLocalCurriculum(isRemoved, curriculumId) {
        this.localCurricula.forEach(curriculum => {
          if (curriculum.Id === curriculumId) curriculum.isRemoved = isRemoved
        })
      },

      removeFromCurrentList(listId, curriculumId) {
        this.setRemoveOnLocalCurriculum(true, curriculumId)
        this.removeFromList(listId, curriculumId).then(this.fetchSelectedListsByCurriculaIds)
      },

      addToCurrentListAtIndex(listId, curriculumId, index) {
        const indexToAddCurriculum = this.findIndexToAddCurriculum(index)
        // console.log(`returned index: ${indexToAddCurriculum}`)
        this.setRemoveOnLocalCurriculum(false, curriculumId)
        this.addToListAtIndex(listId, curriculumId, indexToAddCurriculum).then(this.fetchSelectedListsByCurriculaIds)
      },
      blinkDemoMode() {
        EventBus.$emit('vnShow', {
          type: 'danger',
          message: `Attenzione. Non è possibile effettuare operazioni sui dati di esempio.`
        })
      },
      doNothing() {}
    },
    watch: {
      list(newValue, oldValue) {
        this.demoMode = false
        if (oldValue !== null) this.oldListId = oldValue.Id
      },
      curricula(newValue, oldValue) {
        if (this.list && this.oldListId === this.list.Id) {
          // if (!this.isLocalCurriculaLoaded) {
          //  this.localCurricula = oldValue
          //  console.log(this.localCurricula)
          //  this.isLocalCurriculaLoaded = true
          // }
          // console.log(this.localCurricula)
        } else {
          this.isLocalCurriculaLoaded = false
          this.localCurricula = _.map(newValue, x => ({ ...x, isRemoved: false }))
        }
        this.curriculumMemosStore.fetchMemoByCurriculaIds(_.map(newValue, x => x.Id))
      }
    },
    mounted() {
      const self = this
      setTimeout(() => (self.showArrow = true), 100)
    }
  })
